import { lazy } from 'react'
import { createBrowserRouter, Navigate } from 'react-router'

import { RouteError } from '@/components/ErrorBoundary'
import RootLayout from '@/components/layout'
import { STORAGE_KEY } from '@/constants/common'

const hostname = window.location.hostname

const isTest = hostname === 'test.betsol.meme'
const isDev = import.meta.env.VITE_MODE === 'development'

export enum RoutePath {
  HOME = '/',
  CREATE = '/create',
  AIRDROP = '/airdrop',
  INFLUENCE = '/influence',
  INFLUENCE_POINTS = '/influence/points',
  REFERRAL = '/referral',
  REFERRAL_POINTS = '/referral/points',
  MINING = '/mining',
  MINING_PLATFORM = '/mining/platform',
  MINING_PLATFORM_POINTS = '/mining/platform/points',
  MINING_INFLUENCE = '/mining/influence',
  MINING_INFLUENCE_POINTS = '/mining/influence/points',
  DAO = '/dao',
  COIN = '/coin',
  MY_COIN = '/my-coin',
  COIN_DETAIL = '/coin/detail',
  STAKING = '/staking',
  PROPOSAL = '/proposal',
  PROPOSAL_DETAIL = '/proposal/detail',
  VOTE = '/vote',
  VOTE_DETAIL = '/vote/detail',
  X_CALLBACK = '/xcallback',
  ERROR = '*'
}

const lazyWithProgress = (importFunc: () => Promise<any>) => {
  return lazy(() => {
    window.NProgress.start()
    return importFunc()
      .then((module) => {
        window.localStorage.setItem(STORAGE_KEY.ERROR_RELOAD_COUNT, '0')
        return module
      })
      .catch(() => {
        let errorCount = Number(
          window.localStorage.getItem(STORAGE_KEY.ERROR_RELOAD_COUNT)
        )
        if (Number.isNaN(errorCount)) {
          errorCount = 0
        }
        if (errorCount < 5) {
          errorCount++
          window.localStorage.setItem(
            STORAGE_KEY.ERROR_RELOAD_COUNT,
            String(errorCount)
          )
          window.location.reload()
        }
      })
      .finally(() => {
        window.NProgress.done()
      })
  })
}

const fatRouters =
  isTest || isDev
    ? [
        {
          path: RoutePath.STAKING,
          Component: lazyWithProgress(() => import('@/pages/Staking'))
        },
        {
          path: RoutePath.PROPOSAL,
          Component: lazyWithProgress(() => import('@/pages/Proposal'))
        },
        {
          path: RoutePath.PROPOSAL_DETAIL + '/:id',
          Component: lazyWithProgress(() => import('@/pages/ProposalDetail'))
        },
        {
          path: RoutePath.VOTE,
          Component: lazyWithProgress(() => import('@/pages/Proposal'))
        },
        {
          path: RoutePath.VOTE_DETAIL + '/:id',
          Component: lazyWithProgress(() => import('@/pages/ProposalDetail'))
        }
      ]
    : []

const router = createBrowserRouter([
  {
    path: RoutePath.HOME,
    Component: RootLayout,
    errorElement: <RouteError />,
    children: [
      // {
      //   index: true,
      //   Component: lazyWithProgress(() => import('@/pages/Home'))
      // },
      // {
      //   path: RoutePath.CREATE,
      //   Component: lazyWithProgress(() => import('@/pages/Create'))
      // },
      {
        index: true,
        handle: {
          parent: RoutePath.AIRDROP,
        },
        Component: lazyWithProgress(() => import('@/pages/Airdrop'))
      },
      {
        path: RoutePath.AIRDROP,
        Component: lazyWithProgress(() => import('@/pages/Airdrop'))
      },
      {
        path: RoutePath.INFLUENCE,
        Component: lazyWithProgress(() => import('@/pages/Airdrop'))
      },
      {
        path: RoutePath.INFLUENCE_POINTS,
        handle: {
          parent: RoutePath.INFLUENCE,
        },
        Component: lazyWithProgress(() => import('@/pages/Influence/PointRecords'))
      },
      {
        path: RoutePath.REFERRAL,
        Component: lazyWithProgress(() => import('@/pages/Airdrop'))
      },
      {
        path: RoutePath.REFERRAL_POINTS,
        handle: {
          parent: RoutePath.REFERRAL,
        },
        Component: lazyWithProgress(() => import('@/pages/Influence/ReferralRecords'))
      },
      // {
      //   path: RoutePath.MINING,
      //   Component: () => <Navigate to={RoutePath.MINING_PLATFORM} replace />
      // },
      // {
      //   path: RoutePath.MINING_PLATFORM,
      //   Component: lazyWithProgress(() => import('@/pages/Airdrop'))
      // },
      // {
      //   path: RoutePath.MINING_PLATFORM_POINTS,
      //   Component: lazyWithProgress(() => import('@/pages/Mining/PointRecords'))
      // },
      // {
      //   path: RoutePath.MINING_INFLUENCE,
      //   Component: lazyWithProgress(() => import('@/pages/Airdrop'))
      // },
      // {
      //   path: RoutePath.MINING_INFLUENCE_POINTS,
      //   Component: lazyWithProgress(
      //     () => import('@/pages/Influence/PointRecords')
      //   )
      // },
      // {
      //   path: RoutePath.COIN,
      //   Component: () => <Navigate to={RoutePath.HOME} replace />
      // },
      // {
      //   path: RoutePath.COIN + '/:mint',
      //   Component: lazyWithProgress(() => import('@/pages/Coin'))
      // },
      // {
      //   path: RoutePath.MY_COIN,
      //   Component: lazyWithProgress(() => import('@/pages/MyCoin'))
      // },
      // {
      //   path: RoutePath.COIN_DETAIL + '/:mint',
      //   Component: lazyWithProgress(() => import('@/pages/CoinDetail'))
      // },
      // {
      //   path: RoutePath.DAO,
      //   Component: lazyWithProgress(() => import('@/pages/Dao'))
      // },
      {
        path: RoutePath.ERROR,
        Component: lazyWithProgress(() => import('@/pages/404'))
      }
    ].concat(fatRouters)
  },
  {
    path: RoutePath.X_CALLBACK,
    Component: () => (
      <Navigate
        to={
          (window.localStorage.getItem(STORAGE_KEY.BEFORE_AUTH_ROUTE) ||
            RoutePath.HOME) + location.search
        }
        replace
      />
    )
  }
])

export default router
